import React, { memo } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { dallas, byOthers, smartLock, handlePull, pull } from "./defaults";
import Choices from "../Choices";
import { Image } from "cloudinary-react";
import {
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  Divider,
  Badge,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useHandleSelector from "./useHandleSelector";
import { styled } from "@mui/material/styles";
import {
  bluetoothHandles,
  emtekColors,
  handleColors,
} from "../Handle/defaults";
import PleaseNote from "../PleaseNote";

const StyledSpan = styled("span")({
  color: "red",
  fontWeight: "bold",
  fontSize: 22,
});

const StyledTypography = styled(Typography)({
  fontWeight: "bold",
  paddingRight: 20,
  alignSelf: "flex-start",
});

const StyledBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    backgroundColor: "#f0be07",
  },
});

function PivotHandleAccordian() {
  const {
    handleChange,
    handleClick,
    handleColor,
    handleStyle,
    bluetoothHandleImg,
    bluetoothHandleWifi,
    handleWifiChange,
    bluetoothExtHandle,
    handleBluetoothExtHandleChange,
    showHandlePulls,
    handlePullLengthChange,
    handlePullLengthOptions,
    handlePullLength,
    handlePullColors,
    handlePullSideChange,
    handlePullSide,
    handlePullSelected,
  } = useHandleSelector();

  const displayBluetooth = handleStyle === "Smart Lock *" ? true : false;

  return (
    <ReusableAccordian
      accordionName="handle"
      heading="Pivot Handle"
      secondaryHeading="Select Pivot Handle"
      colOrRow="col"
    >
      {displayBluetooth ? (
        <div style={{ height: 44 }} />
      ) : (
        <RowLayout style={{ paddingBottom: 20, margin: 0 }}>
          <InfoIcon color="primary" style={{ marginRight: 10 }} />
          <PleaseNote notes="Comes equipped with multi-point locking hardware as standard." />
        </RowLayout>
      )}

      <RowLayout>
        <div
          onClick={() => handleClick(byOthers.label)}
          style={{ paddingRight: 20 }}
        >
          <Choices
            label={
              <>
                <span>Handle Pull</span>{" "}
                <span style={{ fontWeight: "bold" }}>by Others</span>
              </>
            }
            variant={byOthers.label === handleStyle ? "filled" : "outlined"}
            checkMark={byOthers.label === handleStyle}
            wide={true}
          />
        </div>

        <div
          onClick={() => handleClick(pull.label)}
          style={{ paddingRight: 20 }}
        >
          <StyledBadge badgeContent={"New!"}>
            <Choices
              label={pull.label}
              variant={showHandlePulls ? "filled" : "outlined"}
              checkMark={showHandlePulls ? true : false}
              wide={true}
            />
          </StyledBadge>
        </div>

        <div
          onClick={() => handleClick(dallas.label)}
          style={{ paddingRight: 20 }}
        >
          <Choices
            label={dallas.label}
            variant={dallas.label === handleStyle ? "filled" : "outlined"}
            checkMark={dallas.label === handleStyle}
            wide={true}
          />
        </div>

        <div
          onClick={() => handleClick(smartLock.label)}
          style={{ paddingRight: 20 }}
        >
          <Choices
            label={smartLock.label}
            variant={smartLock.label === handleStyle ? "filled" : "outlined"}
            checkMark={smartLock.label === handleStyle}
            wide={true}
          />
        </div>
      </RowLayout>

      {showHandlePulls && (
        <ColLayout>
          <Divider style={{ width: "100%" }} />
          <Typography style={{ paddingTop: 10, fontWeight: "bold" }}>
            Handle Pulls
          </Typography>

          <RowLayout>
            {handlePull.map((itm) => (
              <div key={itm.id} onClick={() => handleClick(itm.label)}>
                <Choices
                  label={itm.label}
                  variant={itm.label === handleStyle ? "filled" : "outlined"}
                  checkMark={itm.label === handleStyle}
                />
              </div>
            ))}
          </RowLayout>
        </ColLayout>
      )}

      {displayBluetooth && (
        <ColLayout>
          <RowLayout style={{ marginBottom: 0 }}>
            {bluetoothHandleImg && (
              <ColLayout style={{ marginRight: 20 }}>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={bluetoothHandleImg}
                />

                <Typography style={{ paddingTop: 10 }} variant="subtitle2">
                  Exterior Handle
                </Typography>
              </ColLayout>
            )}

            <RowLayout
              style={{
                paddingRight: 20,
                marginBottom: 0,
                alignItems: "flex-end",
              }}
            >
              <ColLayout
                style={{ marginLeft: 20, marginRight: 40, marginBottom: 0 }}
              >
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={"Handles/nouvel_lever"}
                />

                <Typography style={{ paddingTop: 5 }} variant="subtitle2">
                  Interior Nouvel Handle
                </Typography>
              </ColLayout>

              <ColLayout
                style={{ marginLeft: 20, marginRight: 40, marginBottom: 0 }}
              >
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={"Handles/bt_deadbolt_nofinish"}
                />
                <Typography style={{ paddingTop: 5 }} variant="subtitle2">
                  Smart Lock
                </Typography>
              </ColLayout>
            </RowLayout>

            <ColLayout>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <RowLayout style={{ margin: 10 }}>
                  <FormControl
                    variant="outlined"
                    style={{ paddingRight: 20, alignItems: "flex-start" }}
                    error={!bluetoothHandleWifi ? true : false}
                  >
                    <InputLabel>
                      Smart Lock Type<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      style={{ width: 250, height: 50 }}
                      label="Smart Lock Type"
                      value={bluetoothHandleWifi}
                      onChange={handleWifiChange}
                    >
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="Bluetooth">Bluetooth</MenuItem>
                      <MenuItem value="Bluetooth & Wi-Fi">
                        Bluetooth & Wi-Fi
                      </MenuItem>
                    </Select>
                  </FormControl>
                </RowLayout>

                <RowLayout style={{ margin: 10 }}>
                  <FormControl
                    variant="outlined"
                    style={{ paddingRight: 20, alignItems: "flex-start" }}
                    error={!bluetoothExtHandle ? true : false}
                  >
                    <InputLabel>
                      Exterior Handle
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      style={{ width: 250, height: 50 }}
                      label="Exterior Handlee"
                      value={bluetoothExtHandle || ""}
                      onChange={handleBluetoothExtHandleChange}
                    >
                      <MenuItem value=""></MenuItem>
                      {bluetoothHandles.map((itm) => (
                        <MenuItem key={itm.id} value={itm.label}>
                          {itm.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </RowLayout>

                <RowLayout style={{ margin: 10 }}>
                  <FormControl
                    variant="outlined"
                    error={!handleColor ? true : false}
                  >
                    <InputLabel id="demo-controlled-open-select-label">
                      Select Finish<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      style={{ width: 250, height: 50 }}
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      label="Select Finish"
                      value={handleColor}
                      onChange={handleChange}
                      required
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {emtekColors?.length ? (
                        emtekColors.map((color) => (
                          <MenuItem key={color} value={color}>
                            {color}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value=""></MenuItem>
                      )}
                    </Select>
                  </FormControl>

                  {handleColor ? (
                    handleColors
                      .filter((color) => color.label === handleColor)
                      .map((item) => (
                        <Image
                          key={item.label}
                          style={{ marginLeft: 40 }}
                          cloudName="ag-millworks"
                          secure="true"
                          publicId={item.img}
                        />
                      ))
                  ) : (
                    <div style={{ width: 50, height: 50, marginLeft: 40 }} />
                  )}
                </RowLayout>
              </div>
            </ColLayout>
          </RowLayout>

          <Typography
            style={{ paddingTop: 40, alignSelf: "flex-start" }}
            variant="subtitle2"
          >
            * All Images are depicted without exterior key or handle finish
          </Typography>

          <Typography
            style={{
              paddingTop: 10,
              fontWeight: "bold",
              alignSelf: "flex-start",
            }}
            variant="subtitle2"
          >
            * Lock stile will be 4-3/4" with single point smart lock
          </Typography>
          <Typography
            style={{ paddingTop: 10, alignSelf: "flex-start" }}
            variant="subtitle2"
          >
            * Access can be granted using a fingerprint scan, touch keypad, or
            the Yale access app
          </Typography>
        </ColLayout>
      )}

      {handleStyle === "Dallas Lever" && (
        <>
          <Typography style={{ paddingTop: 40 }} variant="subtitle2">
            * All Images are depicted without exterior key or handle finish
          </Typography>

          <RowLayout style={{ paddingTop: 20 }}>
            <ColLayout style={{ marginRight: 20 }}>
              <Typography style={{ fontWeight: "bold" }}>
                Lever Finish <StyledSpan>*</StyledSpan>
              </Typography>

              <Select
                onChange={handleChange}
                value={handleColor}
                style={{ minWidth: 150 }}
                size="small"
              >
                <MenuItem value="" />
                <MenuItem value="Stainless Steel">Stainless Steel</MenuItem>
                <MenuItem value="Matte Black">Matte Black</MenuItem>
              </Select>
            </ColLayout>

            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={`Handles/Pivot_Dallas_Lever_${
                handleColor === "Matte Black" ? "Black" : "Steel"
              }`}
            />
          </RowLayout>
        </>
      )}

      {showHandlePulls && handlePullSelected && (
        <>
          <Typography style={{ paddingTop: 40 }} variant="subtitle2">
            * All Images are depicted without exterior key or handle finish
          </Typography>
          <Typography variant="subtitle2">
            * Lock stile will be 4-3/4"
          </Typography>

          <RowLayout style={{ paddingTop: 20 }}>
            <ColLayout style={{ alignItems: "flex-end", paddingRight: 20 }}>
              <RowLayout>
                <StyledTypography>
                  Finish <StyledSpan>*</StyledSpan>
                </StyledTypography>
                <Select
                  onChange={handleChange}
                  value={handleColor}
                  style={{ minWidth: 240 }}
                  size="small"
                >
                  <MenuItem value="" />
                  {handlePullColors.map((itm) => (
                    <MenuItem key={itm} value={itm}>
                      {itm}
                    </MenuItem>
                  ))}
                </Select>
              </RowLayout>

              <RowLayout>
                <StyledTypography>
                  Side <StyledSpan>*</StyledSpan>
                </StyledTypography>
                <Select
                  onChange={handlePullSideChange}
                  value={handlePullSide}
                  style={{ minWidth: 240 }}
                  size="small"
                >
                  <MenuItem value="" />
                  <MenuItem value="Exterior">Exterior</MenuItem>
                  <MenuItem value="Interior/Exterior">
                    Interior/Exterior
                  </MenuItem>
                </Select>
              </RowLayout>

              <RowLayout>
                <StyledTypography>
                  Length <StyledSpan>*</StyledSpan>
                </StyledTypography>
                <Select
                  onChange={handlePullLengthChange}
                  value={handlePullLength}
                  style={{ minWidth: 240 }}
                  size="small"
                >
                  <MenuItem value="" />
                  {handlePullLengthOptions.map((itm) => (
                    <MenuItem key={itm} value={itm}>
                      {itm}
                    </MenuItem>
                  ))}
                </Select>
              </RowLayout>
            </ColLayout>

            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={`Handles/pulls/${handleStyle}_v2`}
            />
          </RowLayout>
        </>
      )}
    </ReusableAccordian>
  );
}

export default memo(PivotHandleAccordian);
